// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/share',
    component: () => import('@/views/Share/Index.vue'),
    name: 'Share',
    meta: {
      roles: [1]
    }
  },
  {
    path: '/projectSharing',
    name: 'ProjectSharing',
    component: layout,
    redirect: '/projectSharing/index',
    meta: {
      title: '项目分享',
      i18Key: 'router.user.projectSharing.index',
      roles: [1],
      category: 'setting'
    },
    sort: 1,
    children: [
      {
        path: 'index',
        name: 'ProjectSharingIndex',
        component: () => import('@/views/ProjectSharing/Index.vue'),
        meta: {
          title: '项目分享',
          i18Key: 'router.user.projectSharing.index',
          roles: [1],
          headerConditions: ['brand']
        }
      }
    ]
  }
]
export default routes
